export default (technologyRisks, response) => {
	if (!technologyRisks || !technologyRisks.itRisks) {
		return technologyRisks;
	}

	const {itRiskId, rejectionRationale, rejectionTypeId, isRejected} = response || {};

	const updatedItRisks = technologyRisks.itRisks.map((risk) => {
		if (risk.itRiskId === itRiskId) {
			return {
				...risk,
				isRejected: isRejected ?? false,
				rejectionRationale: rejectionRationale ?? null,
				rejectionTypeId: rejectionTypeId ?? null
			};
		}
		return risk;
	});

	return {
		...technologyRisks,
		itRisks: updatedItRisks
	};
};